/*
 * @Date: 2022-11-14 11:21:44
 * @Author: 王溪
 * @LastEditTime: 2023-02-07 16:47:57
 * @description: 封装Cookies
 * @FilePath: \enterprisewebe:\code\work_project\pcweb-share\src\utils\Cookies.js
 * @LastEditors: 王溪
 */
import cookies from 'js-cookie';
export let Cookies={
    get(value){
    return cookies.get(value)
    },
    set(name,value,options){
    
  cookies.set(name,value,{path:cookies.get('localhome'),...options})
    },
    remove(value){
        cookies.remove(value,{path:cookies.get('localhome')})
    }
}
 


// WEBPACK FOOTER //
// ./src/utils/Cookies.js